import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  // Always send/receive the httpOnly auth cookie the backend sets on login.
  // The cookie is XSS-resistant (JS cannot read it), so we no longer need Authorization headers
  // on browser sessions. We still forward a Bearer header if a token happens to be in localStorage
  // — preserves any pre-migration sessions and non-browser clients.
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // SECURITY: clear org-scoped client caches alongside the session on forced logout.
      try {
        const keys = Object.keys(localStorage);
        for (const k of keys) {
          if (k.startsWith('pca_filters_') || k.startsWith('ai_cache_')) {
            localStorage.removeItem(k);
          }
        }
      } catch {}
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/auth';
    }
    return Promise.reject(error);
  }
);

export default api;
